import { render, staticRenderFns } from "./Beneficiaries.vue?vue&type=template&id=72e335dc&scoped=true&"
import script from "./Beneficiaries.vue?vue&type=script&lang=js&"
export * from "./Beneficiaries.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=72e335dc&scoped=true&lang=css&"
import style1 from "./Beneficiaries.vue?vue&type=style&index=1&id=72e335dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e335dc",
  null
  
)

export default component.exports